const VISIT_ID = "visit_id";
const VISIT_ID_TS = "visit_id_ts";
const EH_VISIT_ID = "eh_visit_id";
const EH_VISIT_TS = "eh_visit_ts";
const URL_VISIT_IDS = "url_visit_ids";
const EH_PREVIOUS_VISIT_ID = "eh_previous_visit_id";
const TIME_THRESHOLD = 30 * 60;
const LONG_COOKIE_EXPIRATION = new Date(
  Date.now() + 1e3 * 60 * 60 * 24 * 365 * 10
);
export {
  EH_PREVIOUS_VISIT_ID,
  EH_VISIT_ID,
  EH_VISIT_TS,
  LONG_COOKIE_EXPIRATION,
  TIME_THRESHOLD,
  URL_VISIT_IDS,
  VISIT_ID,
  VISIT_ID_TS
};
